export const getUser = (state) => state.user;
export const getToken = (state) => state.token;
export const getLogin = (state) => state.login;
export const isHasRoleApplication = (state) => {
	const planPermissions = state.user.planPermission instanceof Object
		? Object.keys(state.user.planPermission)
		: [];

	const roleApplications = [
		'application_view',
		'download_document_template',
	];

	return state.user.is_role_application 
		&& planPermissions.length === roleApplications.length
		&& roleApplications.every(role => state.user.planPermission[role]);
};
